import React, { useEffect } from 'react';
import { Form, Modal, Typography } from 'antd';
import { DepartmentSelect } from '@/components/finance/DepartmentSelect';

const { Text } = Typography;

export type ConvertCertificationToSalesInvoicePayload = {
  departmentId: string;
};

type Props = {
  open: boolean;
  confirming?: boolean;
  title?: string;
  defaultDepartmentId?: string | null;
  onCancel: () => void;
  onConfirm: (payload: ConvertCertificationToSalesInvoicePayload) => void;
};

/**
 * Department selection before converting a client certification to Draft Progress Sales Invoice.
 * Contract Admin never posts GL — Sales/Finance own AR.
 */
export function ConvertCertificationToSalesInvoiceModal({
  open,
  confirming,
  title = 'Convert to Draft Tax Invoice',
  defaultDepartmentId,
  onCancel,
  onConfirm,
}: Props) {
  const [form] = Form.useForm<{ departmentId: string }>();

  useEffect(() => {
    if (!open) return;
    form.setFieldsValue({
      departmentId: defaultDepartmentId || undefined,
    });
  }, [open, defaultDepartmentId, form]);

  return (
    <Modal
      title={title}
      open={open}
      onCancel={onCancel}
      okText="Create Draft SI"
      confirmLoading={!!confirming}
      destroyOnClose
      onOk={async () => {
        try {
          const values = await form.validateFields();
          onConfirm({ departmentId: values.departmentId });
        } catch {
          /* validation */
        }
      }}
    >
      <Text type="secondary" style={{ display: 'block', marginBottom: 12 }}>
        Creates a Draft Progress Tax Invoice from the certified payment application. Sales /
        Finance own submit, approve, post, and receipt vouchers.
      </Text>
      <Form form={form} layout="vertical">
        <Form.Item
          name="departmentId"
          label="Department"
          rules={[{ required: true, message: 'Department is required' }]}
        >
          <DepartmentSelect placeholder="Select department" />
        </Form.Item>
      </Form>
    </Modal>
  );
}
